/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthData, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthDataFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthDataToJSON, } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthData';
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthData(json)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthData(value)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGoogleGoogleAuthDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestGoogleLogin.js.map